/**
 * Returns the entry fields configuration object
 *
 * @param   {object}  vueComponent
 * @return  {array}
 */
export const getEntryFields = (vueComponent) => {
    let configuration = [
        {
            id: 1,
            label: 'Date from',
            mutation: 'comments/UPDATE_FILTER_VALUE',
            name: 'comment_publish_date_start',
            value: vueComponent.commentPublishDateStart,
            vueComponent: 'DateTime',
        },
        {
            id: 2,
            label: 'Date to',
            mutation: 'comments/UPDATE_FILTER_VALUE',
            name: 'comment_publish_date_end',
            value: vueComponent.commentPublishDateEnd,
            vueComponent: 'DateTime',
        },
        {
            id: 3,
            label: 'Comment status',
            mutation: 'comments/UPDATE_FILTER_VALUE',
            name: 'comment_status',
            optionsData: [
                {
                    id: 'pending',
                    text: 'Pending',
                },
                {
                    id: 'approved',
                    text: 'Approved',
                },
                {
                    id: 'rejected',
                    text: 'Rejected',
                },
                {
                    id: 'flagged',
                    text: 'Flagged',
                },
            ],
            preselectFirst: true,
            required: true,
            value: 'pending',
            vueComponent: 'Relationship',
        },
        {
            id: 4,
            label: 'Filter by article title',
            mutation: 'comments/UPDATE_FILTER_VALUE',
            name: 'title',
            vueComponent: 'InputText',
        },
    ];

    return configuration;
};
